import { Tile } from "../../../../components/Tile";
import { styled } from "../../../../styles";

export const SecurityContainer = styled(Tile, {
  width: "100%",
  height: "160px",
  display: "flex",
  alignItems: "center",
  justifyContent: "left",
  backgroundColor: "$white",
  marginTop: "6px",
  padding: "0 0 30px 55px",
  fontSize: "14px",
  fontWeight: "500",
  color: "#666666",
});

export const EnabledButton = styled("button", {
  // EN-5191: was a fixed 124x36, sized around the English label. A longer translation
  // overflowed the width and the fixed height clipped the wrapped line. The minimums keep
  // the English button pixel-identical while a longer language grows instead of breaking.
  width: "max-content",
  minWidth: "124px",
  minHeight: "36px",
  whiteSpace: "nowrap",
  padding: "0 12px",
  marginLeft: "8%",
  borderRadius: "18px",
  border: "1px solid #E6E6E6",
  fontSize: "14px",
  fontWeight: "400",
  cursor: "pointer",
  color: "#666666",
  background: "$white",
  fontFamily: "$openSans",

  "&:focus": {
    outline: "none",
    border: "2px solid var(--colors-button-focus-border)",
  },
});
